import React from "react"
import {Page} from "~/layout/page"
import {Navbar} from "~/layout/page-navbar"
import {Features} from "~/modules/landing/features"
import {Jumbotron} from "~/modules/landing/jumbotron"
import {Services} from "~/modules/landing/services"
import {WhyDoxpro} from "~/modules/landing/why-doxpro"
import "./index.scss"

export default function Index() {
  return (
    <Page title="Doxpro | PowerPoint, Excel template kits and add-ins for consultants">
      <Navbar />
      <Jumbotron />
      <WhyDoxpro />
      <Features />
      <Services />
    </Page>
  )
}
